import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import logoSm from "../../assets/images/logo-sm.png";
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-light.png";
import SuperAdmin from "./SuperAdmin";
import Operator from "./Operator";
import Gacema from "./Gacema";
import Daxarisxeba from "./Daxarisxeba";

const Sidebar = props => {


  function tToggle() {
    var body = document.body;
    body.classList.toggle("vertical-collpsed");
    body.classList.toggle("sidebar-enable");
  }

  return (
    <React.Fragment>
      <div className="vertical-menu">


        {
          props.auth.isAuthenticated === true
              ?
              <>
                {
                  props.auth.admin.role !== 5
                      ?
                      <div className="navbar-brand-box">
                        <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
                          <span className="logo-lg">
              <img src={logoDark} alt="" height="20" />
            </span>
                        </Link>

                        <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
                          <span className="logo-lg">
              <img src={logoLight} alt="" height="20" />
            </span>
                        </Link>
                      </div>

                      :
                      <div className="navbar-brand-box">
                        <Link to="/warehouse" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
                          <span className="logo-lg">
              <img src={logoDark} alt="" height="20" />
            </span>
                        </Link>

                        <Link to="/warehouse" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoSm} alt="" height="22" />
            </span>
                          <span className="logo-lg">
              <img src={logoLight} alt="" height="20" />
            </span>
                        </Link>
                      </div>

                }

              </>
              : null
        }










        <button
          onClick={() => {
            tToggle();
          }}
          type="button" className="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn">
          <i className="fa fa-fw fa-bars"></i>
        </button>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
      </div>
    </React.Fragment>
  );
};
/*

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
*/
const mapStateToProps = state => {
  const {
    information,
    auth
  } = state
  return {
    information,
    auth
  }
};
export default withRouter(connect(mapStateToProps)(Sidebar))
